import { useState } from "react";
import { CheckCircle2, Circle, ArrowRight, X } from "lucide-react";
import api from "@/lib/api";

const STEP_COPY = {
  profile: ["Complete your profile", "Add a photo and a short description so people know who you are."],
  offering: ["Add an offering", "Create at least one service people can book."],
  payouts: ["Connect Stripe for payouts", "So your earnings are paid straight to your bank."],
  availability: ["Set your availability", "Choose the days and hours people can book."],
  media: ["Publish your first piece of media", "A video, podcast or replay helps people get to know your work."],
};

// Getting Started checklist; hides itself once every step is done or it's dismissed.
export default function SetupChecklist({ role, steps, dismissed, go, onDismissed }) {
  const [hidden, setHidden] = useState(dismissed);
  const done = steps.filter((s) => s.done).length;
  if (hidden || done === steps.length) return null;
  const dismiss = async () => { setHidden(true); try { await api.post("/dashboard/checklist/dismiss", { role }); onDismissed?.(); } catch { /* stays hidden this session */ } };
  return (
    <div className="eyw-card p-6 border-l-4 border-l-[#144F75]" data-testid={`setup-checklist-${role}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl text-[#1A242B]">Getting started</h3>
          <p className="text-sm text-[#4A5D6B]">{done} of {steps.length} done. Each step takes you straight to the right place.</p>
        </div>
        <button onClick={dismiss} aria-label="Dismiss checklist" data-testid="setup-checklist-dismiss" className="text-[#8FA89B] hover:text-[#1A242B] p-1"><X size={18} /></button>
      </div>
      <div className="h-1.5 rounded-full bg-[#E5E0D8] overflow-hidden my-4">
        <div className="h-full bg-[#144F75] transition-[width] duration-500" style={{ width: `${(done / steps.length) * 100}%` }} />
      </div>
      <ul className="space-y-1">
        {steps.map((s) => {
          const [title, desc] = STEP_COPY[s.key];
          return (
            <li key={s.key}>
              <button onClick={() => go(s.tab)} data-testid={`setup-step-${s.key}`} disabled={s.done}
                className="group w-full flex items-start gap-3 rounded-xl px-3 py-2.5 text-left hover:bg-[#144F75]/[0.05] disabled:hover:bg-transparent transition-colors">
                {s.done ? <CheckCircle2 size={20} className="text-[#5C8A72] shrink-0 mt-0.5" /> : <Circle size={20} className="text-[#C9C0B2] shrink-0 mt-0.5" />}
                <span className="flex-1 min-w-0">
                  <span className={`block text-sm font-medium ${s.done ? "text-[#8FA89B] line-through" : "text-[#1A242B]"}`}>{title}</span>
                  {!s.done && <span className="block text-xs text-[#4A5D6B]">{desc}</span>}
                </span>
                {!s.done && <ArrowRight size={15} className="text-[#144F75] mt-1 transition-transform group-hover:translate-x-0.5" />}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
